
import React, {useEffect, useState} from "react";
import {
  useHistory,
  useLocation,
  Link
} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, Image, Container, InputGroup, Alert } from 'react-bootstrap';

import BgImage from "../assets/img/vite/vitebackground.png";
import BgIllustration from "../assets/img/illustrations/signin.svg";
import Logo from "../assets/img/vite/ViteLogoOnly.png";
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useAuth } from "../hooks/auth.hook";
import LoadingComponent from "../components/LoadingComponent";
import { errorToast, successToast } from "../utils/toast";


function Recover() {
  let auth = useAuth();
  let history = useHistory();
  let location = useLocation();
  let { from } = location.state || { from: { pathname: "/dashboard" } };

  const RecoverSchema = yup.object({
    email: yup.string().email("Debes ingresar un correo electrónico válido").max(320).required('El correo electrónico no puede estar vacío')
    .matches(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, 'Ingresa un correo de electrónico válido válido'),
  });

  const handleLoginSubmit = (values, { setSubmitting }) => {
    //start loader here
    setSubmitting(true);
    setIsLoading(true);
    auth.recoverAccountRequest(values.email,)
        .then((result) => {
            // result is true always
            history.push({
              pathname: "/login",
              state: {
                // location state
                success_restart: null,
                valid_email: null,
                success_request: true,
              },
            });
        })
        .catch((error) => {
          //remove loader
          setIsLoading(false);
          console.log(error);
          errorToast(error);
        })
        .finally(() => {
            setSubmitting(false);
            setIsLoading(false);
        });
  };
  const formik = useFormik({
    initialValues: {  email: ''},
    validationSchema: RecoverSchema,
    onSubmit: handleLoginSubmit,
  });
  const [isLoading, setIsLoading] = useState(false);

  return (
    <main>
      <section className="d-flex align-items-center">
        <Container fluid style={{ backgroundImage: `url(${BgIllustration})`, backgroundRepeat: `no-repeat`, height: `100vh`, width: `100vw` }}>
          <Container className=" my-5 mt-lg-6 mb-lg-5">
          <Row className="justify-content-center form-bg-image">
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              {isLoading && (
                  <>
                    <LoadingComponent className="d-flex align-items-center justify-content-center fmxw-500"></LoadingComponent>
                  </>
              )}
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="d-flex align-items-center justify-content-center">
                    <Image src={Logo} style={{width: `240px`}}></Image>
                </div>
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Recuperar mi cuenta de ViteCapital TradeCalc</h3>
                </div>
                <Alert variant="info">
                  <div className="text-center text-md-center mb-4 mt-md-0">
                    <h6 className="mb-0">Se enviará un correo de confirmación para poder restaurar tu contraseña</h6>
                  </div>
                </Alert>
                <Form className="mt-4" onSubmit={formik.handleSubmit} method="post">
                  <Form.Group className="mb-4">
                    <Form.Label>Correo electrónico</Form.Label>
                       <InputGroup>
                         <Form.Control
                            required 
                            id="email"
                            type="text" 
                            maxLength="120"
                            placeholder="micorreo@vitecp.com"
                            className={` ${(formik.touched.email && formik.errors.email) ? "invalid" : ""} ${(formik.touched.email && !formik.errors.email) ? "valid" : ""}`}
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}/>
                       </InputGroup>
                            {formik.touched.email && formik.errors.email  &&
                                <div style={{ position: "absolute", display: "flex" }}>
                                  <small className="invalid-feedback" style={{ display: "inline-block" }}> <FontAwesomeIcon icon={faExclamationCircle} /> {formik.errors.email}</small>
                                </div>
                              }
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100">
                    Enviar correo de recuperación
                  </Button>
                </Form>
                <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    ¿No estás registrado?
                    <Card.Link as={Link} to={"/register"} className="fw-bold">
                      {` Crear cuenta `}
                    </Card.Link>
                  </span>
                </div>
                <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    ¿Ya tienes cuenta?
                    <Card.Link as={Link} to={"/login"} className="fw-bold">
                      {` Iniciar sesión`}
                    </Card.Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          </Container>
        </Container>
      </section>
    </main>
  );
};

export default Recover;